import { INSURANCE_LIMIT } from '../consts/insurance.const';
import type { CalculateOrderResponse } from '../models/calculation.types';
import { moneyMinorToRubles } from './money';

interface CheckoutPriceViewParams {
  calculationResponse: CalculateOrderResponse | null;
  calculationIncludesInsurance: boolean | null;
  initialTicketsPrice: number;
  insuranceAvailable: boolean;
  isInsuranceSelected: boolean;
}

export const getCheckoutPriceView = ({
  calculationResponse,
  calculationIncludesInsurance,
  initialTicketsPrice,
  insuranceAvailable,
  isInsuranceSelected,
}: CheckoutPriceViewParams) => {
  const calculatedPrice = calculationResponse?.price;
  const calculatedTicketsPrice = moneyMinorToRubles(calculatedPrice?.ticketsBeforeDiscount);
  const calculatedTicketsAfterDiscount = moneyMinorToRubles(calculatedPrice?.ticketsAfterDiscount);
  const discountAmount = moneyMinorToRubles(calculatedPrice?.discountAmount);
  const serviceFee = moneyMinorToRubles(calculatedPrice?.serviceFeeAmount);
  const insuranceAmount = moneyMinorToRubles(calculatedPrice?.insuranceAmount);
  const totalWithoutInsurance = moneyMinorToRubles(calculatedPrice?.totalWithoutInsurance);
  const calculatedTotalAmount = moneyMinorToRubles(calculatedPrice?.totalAmount);
  const hasServerCalculation = calculationResponse !== null;
  const insuranceTicketsPrice = hasServerCalculation
    ? calculatedTicketsAfterDiscount
    : initialTicketsPrice;
  const isInsuranceAvailable =
    insuranceAvailable &&
    insuranceTicketsPrice !== null &&
    insuranceTicketsPrice > 0 &&
    insuranceTicketsPrice <= INSURANCE_LIMIT;
  const hasInsurance = isInsuranceAvailable && isInsuranceSelected;

  return {
    ticketsPrice: hasServerCalculation ? calculatedTicketsPrice : initialTicketsPrice,
    discountAmount: hasServerCalculation ? discountAmount : 0,
    serviceFee: hasServerCalculation ? serviceFee : null,
    insuranceAmount,
    insurancePremium: hasInsurance ? insuranceAmount : null,
    isInsuranceAvailable,
    hasInsurance,
    totalAmount: hasServerCalculation
      ? !hasInsurance && calculationIncludesInsurance
        ? totalWithoutInsurance
        : calculatedTotalAmount
      : null,
  };
};
